export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    appear_lines: [
      0,
      1322.0861678004535,
    ],
    big_win: [
      3000,
      5551.020408163265,
    ],
    button_spin: [
      10000,
      1127.6190476190475,
    ],
    cascade_explosion: [
      13000,
      2953.287981859411,
    ],
    cascade_spin: [
      17000,
      2056.41723356009,
    ],
    end_free_spin: [
      21000,
      3168.0725623582757,
    ],
    free_bet_big_win: [
      26000,
      1377.2335600907013,
    ],
    free_bet_mega_win: [
      29000,
      2213.151927437643,
    ],
    free_bet_total_win: [
      33000,
      979.5918367346915,
    ],
    free_bet_ultra_win: [
      35000,
      1319.1836734693893,
    ],
    free_spin_ambient: [
      38000,
      45554.6485260771,
    ],
    free_spin_music: [
      85000,
      36870.38548752835,
    ],
    free_spin_popup: [
      123000,
      4715.102040816333,
    ],
    free_spin_start: [
      129000,
      6578.5034013605355,
    ],
    inside_buttons: [
      137000,
      178.5034013605582,
    ],
    main_ambient: [
      139000,
      67365.44217687074,
    ],
    main_music: [
      208000,
      132661.4058956916,
    ],
    mega_win: [
      342000,
      8468.027210884373,
    ],
    mult_land: [
      352000,
      3011.337868480723,
    ],
    mult_port: [
      357000,
      3626.666666666665,
    ],
    outside_buttons: [
      362000,
      230.74829931971408,
    ],
    reel_spin: [
      364000,
      2278.4580498866376,
    ],
    reel_stop_01: [
      368000,
      143.67346938774972,
    ],
    reel_stop_02: [
      370000,
      97.23356009072859,
    ],
    reel_stop_03: [
      372000,
      108.84353741494124,
    ],
    reel_stop_04: [
      374000,
      120.45351473921073,
    ],
    reel_stop_05: [
      376000,
      134.9659863945476,
    ],
    regular_win: [
      378000,
      1139.2290249432904,
    ],
    tap_to_play: [
      381000,
      6677.18820861677,
    ],
    ultra_win: [
      389000,
      6450.793650793628,
    ],
  },
}
